<nz-modal
  nzWrapClassName=""
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="onClose()"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}">
  <ng-template #modalTitle>
  </ng-template>

  <ng-template #modalContent>
    <div class="d-flex justify-content-center align-items-center flex-column">
      <!-- una imagen cuando quieres bajar el plan y no se puede por exceder el num de recursos -->
      <img loading="lazy" src="./../../../assets/images/wrong-down-plan.jpg" alt="" style="height: 220px;" *ngIf="type === 'down-wrong'">
      <p class="text-info mt-xlg text-center" *ngIf="type === 'down-wrong'">
        ¡Ups! No es posible bajar el alcance del plan debido a que actualmente se excede el número de recursos que este plan brinda.
      </p>
      <!-- una imagen cuando quieres bajar y si puede -->
      <img loading="lazy" src="./../../../assets/images/change-plan.jpg" alt="" style="height: 220px;" *ngIf="type === 'down-success'">
      <p class="text-info mt-xlg text-center" *ngIf="type === 'down-success'">
        ¡Bien! Tu plan ha sido disminuido exitosamente.
      </p>
      <!-- una imagen cuando cambia y si puede -->
      <img loading="lazy" src="./../../../assets/images/change-plan.jpg" alt="" style="height: 220px;" *ngIf="type === 'success'">
      <p class="text-info mt-xlg text-center" *ngIf="type === 'success'">
        {{ isSubscribe ? '¡Felicidades! Tu ya cuentas con una nueva suscripción.' : '¡Bien! Tu plan ha sido actualizado exitosamente.' }}
      </p>
      <!-- una imagen cuando quieres subir -->
      <img loading="lazy" src="./../../../assets/images/success-up-plan.jpg" alt="" style="height: 220px;" *ngIf="type === 'up-success'">
      <p class="text-info mt-xlg text-center" *ngIf="type === 'up-success'">
        ¡Genial! Tu plan ha sido aumentado, ya puedes registrar más <span class="text-link">sucursales, expertos y pacientes</span>.
      </p>
    </div>
  </ng-template>

  <ng-template #modalFooter>
  </ng-template>
</nz-modal>
